import script from "./ServiceApi.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceApi.vue?vue&type=script&setup=true&lang=js"

import "./ServiceApi.vue?vue&type=style&index=0&id=731af510&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-731af510"]])

export default __exports__